// extracted by mini-css-extract-plugin
export default {"PasswordReset":"PasswordReset_PasswordReset__9pPO8","FormError":"PasswordReset_FormError__mFAy9"};